module.exports = function () {
  "use strict";

  var n = {
    498: function _(n, e, t) {
      t.r(e), t.d(e, {
        Upload: function Upload() {
          return R;
        },
        UploadApiError: function UploadApiError() {
          return m;
        }
      });

      var r = require("@upload-io/upload-api-client-upload-js");

      function o() {}

      function i(n, e, t) {
        if (!n.s) {
          if (t instanceof u) {
            if (!t.s) return void (t.o = i.bind(null, n, e));
            1 & e && (e = t.s), t = t.v;
          }

          if (t && t.then) return void t.then(i.bind(null, n, e), i.bind(null, n, 2));
          n.s = e, n.v = t;
          var r = n.o;
          r && r(n);
        }
      }

      var u = function () {
        function n() {}

        return n.prototype.then = function (e, t) {
          var r = new n(),
              o = this.s;

          if (o) {
            var u = 1 & o ? e : t;

            if (u) {
              try {
                i(r, 1, u(this.v));
              } catch (n) {
                i(r, 2, n);
              }

              return r;
            }

            return this;
          }

          return this.o = function (n) {
            try {
              var o = n.v;
              1 & n.s ? i(r, 1, e ? e(o) : o) : t ? i(r, 1, t(o)) : i(r, 2, o);
            } catch (n) {
              i(r, 2, n);
            }
          }, r;
        }, n;
      }();

      function a(n) {
        return n instanceof u && 1 & n.s;
      }

      function c() {
        var n,
            e,
            t,
            r = (t = function t() {
          return r = function r() {
            n = new Promise(function (n) {
              e = n;
            });
          }, (t = function (n, e, t) {
            for (var r;;) {
              var o = n();
              if (a(o) && (o = o.v), !o) return f;

              if (o.then) {
                r = 0;
                break;
              }

              var c,
                  f = t();

              if (f && f.then) {
                if (!a(f)) {
                  r = 1;
                  break;
                }

                f = f.s;
              }
            }

            var l = new u(),
                s = i.bind(null, l, 2);
            return (0 === r ? o.then(p) : 1 === r ? f.then(d) : c.then(v)).then(void 0, s), l;

            function d(e) {
              f = e;

              do {
                if (!(o = n()) || a(o) && !o.v) return void i(l, 1, f);
                if (o.then) return void o.then(p).then(void 0, s);
                a(f = t()) && (f = f.v);
              } while (!f || !f.then);

              f.then(d).then(void 0, s);
            }

            function p(n) {
              n ? (f = t()) && f.then ? f.then(d).then(void 0, s) : d(f) : i(l, 1, f);
            }

            function v() {
              (o = n()) ? o.then ? o.then(p).then(void 0, s) : p(o) : i(l, 1, f);
            }
          }(function () {
            return void 0 !== n;
          }, 0, function () {
            return function (n, e) {
              return n && n.then ? n.then(o) : Promise.resolve();
            }(n);
          })) && t.then ? t.then(r) : r();
          var t, r;
        }, function () {
          for (var n = [], e = 0; e < arguments.length; e++) {
            n[e] = arguments[e];
          }

          try {
            return Promise.resolve(t.apply(this, n));
          } catch (n) {
            return Promise.reject(n);
          }
        });
        return {
          safe: function safe(t) {
            return function (n, e, t) {
              try {
                var r = Promise.resolve(n());
                return e ? r.then(e) : r;
              } catch (n) {
                return Promise.reject(n);
              }
            }(r, function () {
              return function (n, e) {
                try {
                  var t = n();
                } catch (n) {
                  return e(!0, n);
                }

                return t && t.then ? t.then(e.bind(null, !1), e.bind(null, !0)) : e(!1, t);
              }(t, function (t, r) {
                return function () {
                  if (void 0 === e) throw new Error("Unable to release mutex: already released.");
                  e(), e = void 0, n = void 0;
                }(), function (n, e) {
                  if (n) throw e;
                  return e;
                }(t, r);
              });
            });
          }
        };
      }

      var f = require("progress-smoother");

      function l(n) {
        return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
          return typeof n;
        } : function (n) {
          return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
        })(n);
      }

      function s(n, e) {
        if (e && ("object" === l(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (n) {
          if (void 0 === n) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return n;
        }(n);
      }

      function d(n) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (d = function d(n) {
          if (null === n || (t = n, -1 === Function.toString.call(t).indexOf("[native code]"))) return n;
          var t;
          if ("function" != typeof n) throw new TypeError("Super expression must either be null or a function");

          if (void 0 !== e) {
            if (e.has(n)) return e.get(n);
            e.set(n, r);
          }

          function r() {
            return p(n, arguments, y(this).constructor);
          }

          return r.prototype = Object.create(n.prototype, {
            constructor: {
              value: r,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), h(r, n);
        })(n);
      }

      function p(n, e, t) {
        return (p = v() ? Reflect.construct : function (n, e, t) {
          var r = [null];
          r.push.apply(r, e);
          var o = new (Function.bind.apply(n, r))();
          return t && h(o, t.prototype), o;
        }).apply(null, arguments);
      }

      function v() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (n) {
          return !1;
        }
      }

      function h(n, e) {
        return (h = Object.setPrototypeOf || function (n, e) {
          return n.__proto__ = e, n;
        })(n, e);
      }

      function y(n) {
        return (y = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
          return n.__proto__ || Object.getPrototypeOf(n);
        })(n);
      }

      var m = function (n) {
        !function (n, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          n.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: n,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(n, "prototype", {
            writable: !1
          }), e && h(n, e);
        }(i, n);
        var e,
            t,
            r,
            o = (e = i, t = v(), function () {
          var n,
              r = y(e);

          if (t) {
            var o = y(this).constructor;
            n = Reflect.construct(r, arguments, o);
          } else n = r.apply(this, arguments);

          return s(this, n);
        });

        function i(n) {
          var e;
          return function (n, e) {
            if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, i), (e = o.call(this, n.error.message)).errorCode = n.error.code, e.details = n.error.details, e;
        }

        return r = i, Object.defineProperty(r, "prototype", {
          writable: !1
        }), r;
      }(d(Error));

      function b(n, e) {
        if (n) throw e;
        return e;
      }

      function g(n, e) {
        try {
          var t = n();
        } catch (n) {
          return e(!0, n);
        }

        return t && t.then ? t.then(e.bind(null, !1), e.bind(null, !0)) : e(!1, t);
      }

      function w(n, e) {
        (null == e || e > n.length) && (e = n.length);

        for (var t = 0, r = new Array(e); t < e; t++) {
          r[t] = n[t];
        }

        return r;
      }

      function P() {}

      function E(n, e) {
        if (!e) return n && n.then ? n.then(P) : Promise.resolve();
      }

      function S(n, e, t) {
        if (t) return e ? e(n()) : n();

        try {
          var r = Promise.resolve(n());
          return e ? r.then(e) : r;
        } catch (n) {
          return Promise.reject(n);
        }
      }

      var T = ["free", "demo"];

      function I(n) {
        return function () {
          for (var e = [], t = 0; t < arguments.length; t++) {
            e[t] = arguments[t];
          }

          try {
            return Promise.resolve(n.apply(this, e));
          } catch (n) {
            return Promise.reject(n);
          }
        };
      }

      var A = "public_";

      function O(n, e, t) {
        return t ? e ? e(n) : n : (n && n.then || (n = Promise.resolve(n)), e ? n.then(e) : n);
      }

      function j(n, e) {
        try {
          var t = n();
        } catch (n) {
          return e(n);
        }

        return t && t.then ? t.then(void 0, e) : t;
      }

      var k = "[upload-js] ";

      function R(n) {
        var e,
            t,
            o,
            i,
            u,
            a,
            l,
            s,
            d,
            p,
            v,
            h = c(),
            y = null !== (t = null === (e = n.internal) || void 0 === e ? void 0 : e.apiUrl) && void 0 !== t ? t : "https://api.upload.io",
            R = null !== (i = null === (o = n.internal) || void 0 === o ? void 0 : o.cdnUrl) && void 0 !== i ? i : "https://upcdn.io",
            U = null === (a = null === (u = n.internal) || void 0 === u ? void 0 : u.authenticateWithApiKey) || void 0 === a || a,
            x = null === (l = n.internal) || void 0 === l ? void 0 : l.headers,
            F = !0 === n.debug;
        if (void 0 === (null != n ? n : void 0)) throw new Error("".concat(k, "Config parameter required."));
        if (!0 === n.debug && console.log("".concat(k, "Initialized with API key '").concat(n.apiKey, "'")), void 0 === (null !== (s = n.apiKey) && void 0 !== s ? s : void 0)) throw new Error("".concat(k, "Please provide an API key via the 'apiKey' config parameter."));
        if (n.apiKey.trim() !== n.apiKey) throw new Error("".concat(k, "API key needs trimming (whitespace detected)."));
        if (!1 === (null === (d = n.internal) || void 0 === d ? void 0 : d.authenticateWithApiKey)) p = n.internal.accountId;else if (T.includes(n.apiKey)) p = "W142hJk";else {
          if (!n.apiKey.startsWith(A)) throw new Error("".concat(k, 'API key must begin with "').concat(A, '".'));
          if (7 !== (p = n.apiKey.substr(A.length, 7)).length) throw new Error("".concat(k, "API key is too short!"));
        }

        var _ = "".concat(R).concat("/api/v1/access_tokens/").concat(p),
            M = I(function () {
          return E(h.safe(I(function () {
            if (void 0 !== v) {
              var n = v;
              return v = void 0, void 0 !== n.accessTokenRefreshHandle && clearTimeout(n.accessTokenRefreshHandle), n.isActive = !1, S(D, P, undefined);
            }
          })));
        }),
            H = I(function (n) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              t = [],
              r = function r(n) {
            t.push(n);
          },
              o = function o() {
            return t.forEach(function (n) {
              return n();
            });
          };

          return void 0 !== e.onBegin && e.onBegin({
            cancel: o
          }), j(function () {
            return O(K(n, e, r));
          }, function (n) {
            throw o(), n;
          });
        }),
            K = I(function (n, e, t) {
          var o = (0, f.ProgressSmoother)({
            maxValue: n.size,
            teardownTime: 1e3,
            minDelayUntilFirstValue: 2e3,
            valueIncreaseDelta: 204800,
            valueIncreaseRatePerSecond: 51200,
            averageTimeBetweenValues: 1e3
          });
          return N(100, function (t) {
            if (void 0 === e.onProgress) t();else {
              var r = o.smoothedValue(),
                  i = n.size;
              r === i && t(), e.onProgress({
                bytesSent: r,
                bytesTotal: i,
                progress: Math.round(r / i * 100)
              });
            }
          }, I(function () {
            var i = {
              path: e.path,
              metadata: e.metadata,
              mime: G(n.type),
              originalFileName: n.name,
              size: n.size,
              tags: e.tags
            };
            return X("Initiating file upload. Params = ".concat(JSON.stringify(i))), O((0, r.beginMultipartUpload)($(), p, i), function (e) {
              var i = V(e),
                  u = i.uploadParts.count > 1;
              X("Initiated file upload. Metadata = ".concat(JSON.stringify(i)));

              var a,
                  c,
                  f = (a = 0, function () {
                if (a !== i.uploadParts.count - 1) return ++a;
              }),
                  l = [i.uploadParts.first],
                  s = I(function (n) {
                var e = l.pop();
                if (void 0 !== e) return X("Dequeued part ".concat(e.uploadPartIndex, "."), n), e;
                var t = f();
                if (void 0 !== t) return X("Fetching metadata for part ".concat(t, "."), n), O((0, r.getUploadPart)($(), p, i.uploadId, t), V);
                X("No parts remaining.", n);
              }),
                  d = [],
                  v = function e(r) {
                return O(s(r), function (a) {
                  return function (c) {
                    var f = function () {
                      if (void 0 !== a) {
                        var c = 0;
                        return O(C(n, i.file, u, a, function (n) {
                          var e = n.bytesSent;
                          void 0 === d[r] ? d[r] = e : (d[r] -= c, d[r] += e), c = e;
                          var t = d.reduce(function (n, e) {
                            return n + e;
                          });
                          o.setValue(t);
                        }, t, r), function () {
                          return E(e(r));
                        });
                      }
                    }();

                    if (f && f.then) return f.then(P);
                  }();
                });
              };

              return O(Promise.all((c = Array(5).keys(), function (n) {
                if (Array.isArray(n)) return w(n);
              }(c) || function (n) {
                if ("undefined" != typeof Symbol && null != n[Symbol.iterator] || null != n["@@iterator"]) return Array.from(n);
              }(c) || function (n, e) {
                if (n) {
                  if ("string" == typeof n) return w(n, e);
                  var t = Object.prototype.toString.call(n).slice(8, -1);
                  return "Object" === t && n.constructor && (t = n.constructor.name), "Map" === t || "Set" === t ? Array.from(n) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? w(n, e) : void 0;
                }
              }(c) || function () {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
              }()).map(function (n) {
                return O(v(n));
              })), function () {
                var e = Object.assign({
                  accountId: p,
                  file: n
                }, i.file);
                return X("File upload completed."), e;
              });
            });
          }));
        }),
            z = I(function (n, e, t, r, o, i) {
          var u = new XMLHttpRequest(),
              a = !0;
          return i(function () {
            a && u.abort();
          }), g(function () {
            return O(new Promise(function (i, a) {
              u.upload.addEventListener("progress", function (n) {
                n.lengthComputable && o({
                  bytesSent: n.loaded,
                  bytesTotal: n.total
                });
              }, !1), u.addEventListener("load", function () {
                if (o({
                  bytesSent: r.size,
                  bytesTotal: r.size
                }), 2 === Math.floor(u.status / 100)) {
                  var n = u.getResponseHeader("etag");
                  null == n ? a(new Error("File upload error: no etag header in upload response.")) : i({
                    etag: n
                  });
                } else a(new Error("File upload error: status code ".concat(u.status)));
              }), u.onabort = function () {
                return a(new Error("File upload cancelled."));
              }, u.onerror = function () {
                return a(new Error("File upload error."));
              }, u.ontimeout = function () {
                return a(new Error("File upload timeout."));
              }, u.open("PUT", n), t || (u.setRequestHeader("content-type", e.mime), null !== e.originalFileName && u.setRequestHeader("content-disposition", 'inline; filename="'.concat(encodeURIComponent(e.originalFileName), "\"; filename*=UTF-8''").concat(encodeURIComponent(e.originalFileName)))), u.send(r);
            }));
          }, function (n, e) {
            return a = !1, b(n, e);
          });
        }),
            C = I(function (n, e, t, o, i, u, a) {
          var c = -1 === o.range.inclusiveEnd ? new Blob() : n.slice(o.range.inclusiveStart, o.range.inclusiveEnd + 1);
          return X("Uploading part ".concat(o.uploadPartIndex, "."), a), O(z(o.uploadUrl, e, t, c, i, u), function (n) {
            var e = n.etag;
            return O((0, r.completeUploadPart)($(), p, o.uploadId, o.uploadPartIndex, {
              etag: e
            }), function (n) {
              V(n), X("Uploaded part ".concat(o.uploadPartIndex, "."), a);
            });
          });
        }),
            N = I(function (n, e, t) {
          var r,
              o = new Promise(function (n) {
            r = n;
          }),
              i = !0,
              u = function u() {
            i && (r(), clearInterval(a), i = !1);
          },
              a = setInterval(function () {
            return e(u);
          }, n);

          return g(function () {
            return S(t, function (n) {
              return O(o, function () {
                return n;
              });
            });
          }, function (n, e) {
            return u(), b(n, e);
          });
        }),
            D = I(function () {
          return E(L(_, {}, !0));
        }),
            q = I(function (n, e, t) {
          return function (n) {
            if (n && n.then) return n.then(P);
          }(j(function () {
            return E(h.safe(I(function () {
              if (t.isActive) return S(e, function (r) {
                return O(W(n, r), function (r) {
                  return O(B(_, {}, {
                    accessToken: r
                  }, !0), function (r) {
                    t.accessToken = r.accessToken, t.accessTokenRefreshHandle = window.setTimeout(function () {
                      q(n, e, t).then(function () {}, function (n) {
                        return Q("Permanent error when refreshing access token: ".concat(n));
                      });
                    }, Math.max(0, 1e3 * (r.ttlSeconds - 20)));
                  });
                });
              });
            })));
          }, function (r) {
            return X("Error when refreshing access token: ".concat(r)), O(new Promise(function (n) {
              return setTimeout(n, 5e3);
            }), function () {
              return E(q(n, e, t));
            });
          }));
        }),
            B = I(function (n, e, t, r) {
          return O(J({
            method: "PUT",
            path: n,
            headers: e,
            body: t
          }, r), function (n) {
            return O(V(n));
          });
        }),
            W = I(function (n, e) {
          return O(J({
            method: "GET",
            path: n,
            headers: e
          }, !1), function (n) {
            return O(V(n));
          });
        }),
            L = I(function (n, e, t) {
          return O(J({
            method: "DELETE",
            path: n,
            headers: e
          }, t), function (n) {
            V(n);
          });
        }),
            V = function V(n) {
          var e;
          if (n.ok) return n.body;
          var t = n.body;
          if ("string" == typeof (null === (e = null == t ? void 0 : t.error) || void 0 === e ? void 0 : e.code)) throw new m(t);
          throw new Error("Unexpected API error.");
        },
            J = I(function (n, e) {
          return (0, r.request)({
            BASE: n.path,
            WITH_CREDENTIALS: e
          }, Object.assign(Object.assign({}, n), {
            path: ""
          }));
        }),
            $ = function $() {
          var e = {
            BASE: y,
            WITH_CREDENTIALS: !0
          };
          U && (e.USERNAME = "apikey", e.PASSWORD = n.apiKey);
          var t = null == v ? void 0 : v.accessToken;
          return void 0 === x && void 0 === t || (e.HEADERS = I(function () {
            return O(void 0 === x ? {} : x(), function (n) {
              var e = null == v ? void 0 : v.accessToken;
              return Object.assign(Object.assign({}, n), void 0 === e ? {} : {
                "authorization-token": e
              });
            }, void 0 === x);
          })), e;
        },
            G = function G(n) {
          var e = n.toLowerCase();
          return /^[a-z0-9]+\/[a-z0-9+\-._]+$/.test(e) ? e : void 0;
        },
            X = function X(n, e) {
          F && console.log("".concat(k).concat(n).concat(void 0 !== e ? " (Worker ".concat(e, ")") : ""));
        },
            Q = function Q(n) {
          console.error("".concat(k).concat(n));
        };

        return {
          beginAuthSession: function beginAuthSession(n, e) {
            return S(M, function () {
              var t = {
                accessToken: void 0,
                accessTokenRefreshHandle: void 0,
                isActive: !0
              };
              return v = t, E(q(n, e, t));
            });
          },
          endAuthSession: M,
          uploadFile: H,
          url: function url(n, e) {
            var t,
                r = "string" == typeof e ? {
              slug: e
            } : e;
            return "".concat(R, "/").concat(p, "/").concat(null !== (t = null == r ? void 0 : r.slug) && void 0 !== t ? t : "raw").concat(n).concat(!0 === (null == r ? void 0 : r.auth) ? "?_auth=true" : "");
          }
        };
      }
    }
  },
      e = {};

  function t(r) {
    if (e[r]) return e[r].exports;
    var o = e[r] = {
      exports: {}
    };
    return n[r](o, o.exports, t), o.exports;
  }

  return t.d = function (n, e) {
    for (var r in e) {
      t.o(e, r) && !t.o(n, r) && Object.defineProperty(n, r, {
        enumerable: !0,
        get: e[r]
      });
    }
  }, t.o = function (n, e) {
    return Object.prototype.hasOwnProperty.call(n, e);
  }, t.r = function (n) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(n, "__esModule", {
      value: !0
    });
  }, t(498);
}();